import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://createfpv.com";
const DEFAULT_TITLE = "CreateFPV — FPV Parça Pazaryeri ve Drone Toplama";
const DEFAULT_DESC = "CreateFPV: FPV parça ilanları, teknik karşılaştırma ve 7 adımda uyumlu drone toplama platformu.";
const DEFAULT_IMAGE = `${BASE_URL}/photo/drone.webp`;

function setMetaTag(attrName, attrVal, content) {
  let element = document.querySelector(`meta[${attrName}="${attrVal}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attrName, attrVal);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function setStructuredData(id, schemaJson) {
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(schemaJson);
}

export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  canonical,
  type = "website",
  schema,
  noIndex = false,
}) {
  const location = useLocation();
  const currentUrl = canonical || `${BASE_URL}${location.pathname}${location.search}`;
  const fullTitle = title ? `${title} | CreateFPV` : DEFAULT_TITLE;

  useEffect(() => {
    // Sayfa başlığı
    document.title = fullTitle;

    // Standart Meta Tagler
    setMetaTag("name", "description", description);
    setMetaTag("name", "robots", noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setCanonical(currentUrl);

    // Open Graph
    setMetaTag("property", "og:type", type);
    setMetaTag("property", "og:title", fullTitle);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:url", currentUrl);
    setMetaTag("property", "og:image", image.startsWith("http") ? image : `${BASE_URL}${image}`);
    setMetaTag("property", "og:site_name", "CreateFPV");
    setMetaTag("property", "og:locale", "tr_TR");

    // Twitter Card
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", fullTitle);
    setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", image.startsWith("http") ? image : `${BASE_URL}${image}`);

    // JSON-LD Structured Data
    if (schema) {
      setStructuredData("page-schema-jsonld", schema);
    } else {
      const defaultSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "CreateFPV",
        url: BASE_URL,
        potentialAction: {
          "@type": "SearchAction",
          target: `${BASE_URL}/ilanlar?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      };
      setStructuredData("page-schema-jsonld", defaultSchema);
    }
  }, [fullTitle, description, image, currentUrl, type, schema, noIndex]);

  return null;
}
